// Material
import { Skeleton, styled, SxProps } from '@mui/material'
// Logic
import { RoomTypes } from '@weblite/ts-action/room'
import { getUserFirstName } from '$logic/users'
// Helpers
import { useAsyncFunction } from '$func/async-function.react-hook'
import { AvatarBase } from '$common/avatar/avatar-base'
import { stringToColor } from '$func/string-to-color'
import { RemovePersonIcon } from '$common/icons/remove-person'
import { getAvatarText } from '$func/avatar-text'
import { getRoomImageAndName } from '$func/room-image-and-name'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const StyledSkeleton = styled(Skeleton)`
  margin: 0 2px 0 10px;
`

interface Props {
  roomType: RoomTypes | undefined
  roomId: string
  size?: AvatarSize
  sx?: SxProps
  title: string
}

/**
 * - TODO: background and color
 * - NOTE: Mui uses the first letter of alt in broken links
 */
export function RoomAvatar({
  roomId,
  roomType,
  size = AvatarSize.SM,
  sx,
  title,
}: Props) {
  const { value, error } = useAsyncFunction(
    () => getRoomImageAndName(roomType, roomId),
    [roomType, roomId],
  )
  const { image, name, user, hall } = value || {}
  const backgroundColor =
    roomType === 'PV'
      ? stringToColor(getUserFirstName(user), user?.id)
      : roomType === 'CHANNEL' || roomType === 'GROUP'
      ? stringToColor(hall?.name, roomId)
      : ''

  if (error)
    return <StyledSkeleton variant="circular" width={size} height={size} />
  return (
    <AvatarBase
      src={image}
      alt={name?.toUpperCase()}
      sx={sx}
      backgroundColor={backgroundColor}
      size={size}
      hasDeleted={!!user?.deletedAt}
    >
      {user?.deletedAt ? <RemovePersonIcon /> : getAvatarText(title)}
    </AvatarBase>
  )
}
